import { render, staticRenderFns } from "./miniBuild.vue?vue&type=template&id=baf8d7bc&scoped=true&"
import script from "./miniBuild.vue?vue&type=script&lang=js&"
export * from "./miniBuild.vue?vue&type=script&lang=js&"
import style0 from "./miniBuild.vue?vue&type=style&index=0&id=baf8d7bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf8d7bc",
  null
  
)

export default component.exports